import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { AssessmentQuestion } from "./types";
import { Building2, TrendingUp } from "lucide-react";
import { CompletionActions } from "./CompletionActions";

interface BusinessProfileCompletionScreenProps {
  question: AssessmentQuestion;
  onFinish: () => void;
  onNextAssessment?: () => void;
  scoreIncrease?: number;
}

export function BusinessProfileCompletionScreen({ 
  question, 
  onFinish,
  onNextAssessment,
  scoreIncrease = 18 
}: BusinessProfileCompletionScreenProps) {
  

  return (
    <div className="text-center space-y-8 py-8 w-full max-w-4xl mx-auto min-h-[400px] flex flex-col justify-center">
      <div className="flex justify-center mb-6">
        <div className="flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full">
          <Building2 className="w-8 h-8 text-primary" />
        </div>
      </div>
      
      <div className="space-y-4">
        <h2 className="text-2xl font-semibold text-foreground">
          Business Profile Complete
        </h2>
        <p className="text-lg text-muted-foreground max-w-lg mx-auto">
          Your practice's operational profile is now part of your succession plan. This data informs your Business Performance score and gives your advisory team the context they need to support an accurate valuation and a smooth transition.
        </p>
        <div className="flex items-center justify-center gap-2 text-lg">
          <TrendingUp className="w-5 h-5 text-primary" />
          <span className="text-muted-foreground">
            Your mySuccession score has <span className="text-primary font-semibold">improved by {scoreIncrease}%</span>
          </span>
        </div>
      </div>
      
      <CompletionActions
        onNextAssessment={onNextAssessment || onFinish}
        onViewDashboard={onFinish}
      />
    </div>
  );
}
